import { render, staticRenderFns } from "./bargainQita.vue?vue&type=template&id=0c943ef6&scoped=true&"
import script from "./bargainQita.vue?vue&type=script&lang=js&"
export * from "./bargainQita.vue?vue&type=script&lang=js&"
import style0 from "./bargainQita.vue?vue&type=style&index=0&id=0c943ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c943ef6",
  null
  
)

export default component.exports